import type { ReactNode } from "react";
import { Dialog } from "@/components/ui/Dialog";

export function FeedDetailDialog({
  open,
  title,
  meta,
  children,
  onClose,
}: {
  open: boolean;
  title: string;
  meta?: string;
  children: ReactNode;
  onClose: () => void;
}) {
  return (
    <Dialog open={open} onClose={onClose} title={title} size="lg">
      {meta ? <p className="mb-3 text-sm text-label-secondary">{meta}</p> : null}
      <div className="eh-home-feed-detail text-sm leading-relaxed text-label">{children}</div>
    </Dialog>
  );
}
